import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DriverLoadV2Component } from '../../driver-load-v2/driver-load-v2.component';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { StaffService } from 'src/app/component/staffs/staff-service/staff.service';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { ViolationService } from 'src/app/component/violations-sets/violation-service/violation.service';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { BreakModalService } from 'src/app/modals/break-modal/break-modal-service/break-modal.service';

@Component({
  selector: 'app-planner-load-wrapper',
  templateUrl: './planner-load-wrapper.component.html',
  styleUrls: ['./planner-load-wrapper.component.css']
})
export class PlannerLoadWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('driverLoad', { static: false }) dl: DriverLoadV2Component;

  @Input() drivers;
  @Input() trips;
  @Input() staff;
  @Input() compatibleTrips;
  @Input() date;

  @Input() levelOfService;
  @Input() spaceTypes;
  @Input() corporates;
  @Input() serviceAreas;

  @Output() onTripsLive = new EventEmitter<any>();

  user;
  timeZone;
  wrapper = 'planner';

  constructor(
    private assignTripService: AssigTripsService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private violatioServie: ViolationService,
    private sharedDataService: SharedDataService,
    private breakService : BreakModalService
  ) {
  }

  ngOnInit() {
    console.log('NON-API: compatibleTrips', this.compatibleTrips);
    console.log('NON-API: date', this.date);
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          console.log('user', this.user);
        }
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.dl.getLevelOfService(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.dl.getSpaceTypes(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getCorporate(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffList() {
    this.dl.getStaffList(this.staff);
    return;
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getStaffList(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dl.getServiceAreas(data);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getDrivers() {
    this.dl.getDriverList(this.drivers);

    // this.driverService
    //   .getDrivers(data.userId, data.endPoint, true)
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe(data => {
    //     if (data) {
    //       this.dl.getDriverList(data);
    //     }
    //   }, err => {
    //     sweetAlert('Error', err, 'warning', 'OK');
    //   });
  }

  getAllTrips() {
    let data = [
      {assigns: this.trips}
    ];

    if (this.dl.selectedDriverId) {
      const bucket = this.compatibleTrips[this.dl.selectedDriverId];
      if (bucket && bucket.trips && bucket.trips.length) {
        const driverTrips = {
          _id: this.compatibleTrips[this.dl.selectedDriverId].driver,
          assigns: this.compatibleTrips[this.dl.selectedDriverId].trips
        }
        data.push(driverTrips);
      }
    }

    // if (this.trips && this.trips.length) {
      this.dl.getAllTrips(data);
    // }
    // this.assignTripService
    //   .getOutstandingTrips(payload)
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe(data => {
    //     if (data) {
    //       this.dl.getAllTrips(data);
    //     }
    //   })
  }

  // const driverId = data.driver;
  //   if (driverId && this.compatibleTrips[driverId] && this.compatibleTrips[driverId].trips) {
  //     const trips = this.compatibleTrips[driverId].trips;
  //     console.log('NON-API: getDriverTimelines', trips);
  //     this.dl.getDriverTimelines(trips);
  //   }
  getDriverTimelines(queryString) {
    this.driverService
      .getDriverTimelines(queryString)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.dl.getDriverTimelines(data);
      });
  }

  processBucket(data) {
    if (this.dl.selectedDriverId) {
      this.compatibleTrips[this.dl.selectedDriverId] = {
        driver: this.drivers.find(driver => driver._id === this.dl.selectedDriverId),
        trips: this.dl.driverMainTrips
      }
    }
  }

  getNearbyDriver(payload) {
    this.driverService
      .getNearbyDrivers(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.getNearbyDriversRes(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getViolationData() {
    this.violatioServie.getViolationData().subscribe((data) => {
      if (data) {
        this.dl.getViolationData(data);
      }
    })
  }

  cancelTrip(payload) {
    this.assignTripService
      .removeTrip(payload, payload._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.dl.cancelTrip(payload, data);
        }
      });
  }

  driverBreak(payload) {

    console.log('before: ', this.compatibleTrips);
    this.breakService
      .addDriverBreak(payload).pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          const driverBreak = data;
          if (this.dl.selectedDriverId) {
            if (this.compatibleTrips[this.dl.selectedDriverId]) {
              if (this.compatibleTrips[this.dl.selectedDriverId].trips && this.compatibleTrips[this.dl.selectedDriverId].trips.length) {
                if (payload._id) {
                  const idx = this.compatibleTrips[this.dl.selectedDriverId].trips.findIndex(trip => trip._id === payload._id);
                  this.compatibleTrips[this.dl.selectedDriverId].trips[idx] = driverBreak;
                } else {
                  this.compatibleTrips[this.dl.selectedDriverId].trips.push(driverBreak);
                }
              } else {
                this.compatibleTrips[this.dl.selectedDriverId].trips = [driverBreak];
              }
            } else {
              const trips = {
                driver: this.drivers.find(driver => driver._id === this.dl.selectedDriverId),
                trips: [driverBreak]
              }
              this.compatibleTrips[this.dl.selectedDriverId] = trips;
            }
          }
          this.dl.onBreakModelClose();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });

    console.log('after: ', this.compatibleTrips);
    this.dl.onBreakModelClose();
  }

  makeItLive() {
    let trips = [];
    for (let item of this.dl.driverMainTrips) {
      trips.push(item._id);
    }
    const driver = this.dl.filteredDrivers.find(driver => driver._id === this.dl.selectedDriverId);
    const payload = {
      selectedTrips: trips,
      status: 'offered',
      driver: {
        _id: driver._id,
        displayName: driver.displayName,
        profileImageURL: driver.profileImageURL,
      }
    }
    console.log(payload);
    sweetAlert(
      "Alert",
      "Proceed with making this plan live?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) =>{
      if(result.value){
        this.assignTripService.liveTrips(payload).subscribe((data) => {
          if (data) {
            this.onTripsLive.emit();
            // this.selectedDriver.tripStatus = 'published'
            // this.plannedDrivers -= 1;
            // this.publishedDrivers += 1;
            // this.closeScheduleModal(false);
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        })
      }

    })


  }

  ngOnDestroy() {
  }

}
